/* eslint-disable @next/next/google-font-display */
import { memo } from 'react';
import Head from 'next/head';
import { TAGBrand } from '@shared-components/types';
import LatoRegular from '../assets/fonts/Lato/Lato-Regular.ttf';
import LatoBold from '../assets/fonts/Lato/Lato-Bold.ttf';
import LatoBlack from '../assets/fonts/Lato/Lato-Black.ttf';
export const lovetFontList: {
  href: unknown;
  type?: string;
}[] = [{
  href: LatoRegular,
  type: 'font/ttf'
}, {
  href: LatoBold,
  type: 'font/ttf'
}, {
  href: LatoBlack,
  type: 'font/ttf'
}];
export function getFonts(brand: TAGBrand) {
  if (brand !== TAGBrand.Lovet) {
    return [];
  }
  return lovetFontList;
}
export const FontPreloader = memo(function FontPreloader({
  brand
}: Readonly<{
  brand: TAGBrand;
}>) {
  const fontData = getFonts(brand);
  return <Head>
			{fontData.map((data, i) => {
      const href = data.href as string;
      return /* eslint-disable-next-line @next/next/google-font-display */<link key={`${i}_${href}`} rel="preload" href={href} as="font" type={data.type} crossOrigin=""></link>;
    })}
		</Head>;
});